import React from "react";

const OperatorBalanceRing = ({ available = 0, locked = 0, pending = 0, onClick }) => {
  const avail = Math.max(0, Number(available) || 0);
  const lock = Math.max(0, Number(locked) || 0);
  const pend = Math.max(0, Number(pending) || 0);
  const total = avail + lock + pend || 1;
  const share = avail / total;
  const pct = Math.round(share * 100);

  const size = 108;
  const stroke = 8;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - share);

  const ringColor =
    pct >= 85 ? "#2ecc71" : pct >= 40 ? "#64b5f6" : "#ffa726";

  return (
    <button
      type="button"
      className="oc-balance-ring"
      onClick={onClick}
      aria-label={`${pct} percent of house balance is available`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="rgba(30,136,229,0.12)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={ringColor}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="oc-balance-ring-center">
        <strong>{pct}%</strong>
        <span>available</span>
      </div>
    </button>
  );
};

export default OperatorBalanceRing;
